<script setup lang="ts">
import { computed, ref } from 'vue';

import { TSButtonBulkAction } from 'tsv2-library';
import { MenuOption } from 'tsv2-library/dist/src/components/v2/Menu/Menu.vue';

import RemoveFromList from '../BorrowExtension/Dialog/RemoveFromList.vue';

import { BorrowingBorrowedReturnAsset } from '@/types/borrowing.type';

const selectedData = defineModel<BorrowingBorrowedReturnAsset[]>(
  'selectedData',
  {
    required: true,
  },
);

const showRemoveFromList = ref<boolean>(false);

const bulkOptions = computed<MenuOption[]>(() => {
  const options: MenuOption[] = [
    {
      label: 'Remove from List',
      icon: 'delete-bin',
      danger: true,
      command: (): void => {
        showRemoveFromList.value = true;
      },
    },
  ];

  return options;
});
</script>
<template>
  <div data-ts-name="borrow-return-bulkaction">
    <RemoveFromList
      v-model:selected-data="selectedData"
      v-model:visible="showRemoveFromList"
    />
    <TSButtonBulkAction
      v-model:selected-data="selectedData"
      :options="bulkOptions"
      naming="Asset(s)"
      table-name="borrow-return-table"
    />
  </div>
</template>
